<template>
<div>
    <div>
    <b-table striped hover :items="items"></b-table>
  </div>
    <tr>
        <td type="hidden">{{direction.subscriber_id}}</td><!-- for security reasons-->
        <td>{{direction.street}}</td>
        <td>{{direction.no_ext}}</td>
        <td>{{direction.suburb}}</td>
        <td>{{direction.municipality}}</td>
        <td>{{direction.state}}</td>
        <td>{{direction.cp}}</td>
        <td>{{direction.btw_streets}}</td>
        <td>{{direction.references}}</td>
        <td> <b-button type="button" class="btn btn-dark" @onclick="onEdit" v-b-modal.directions-modal >Editar</b-button></td>
     </tr>
	<b-modal id="directions-modal" title="Elditar dirección">
        <div class="modal-body">
            <div class="data">
                <table>
                    <thead>
                    <th>Edite sus datos</th>
                        </thead>
                            <tbody>
                                <Directions v-for="direccion in addresses" :key="direccion.id" :addresses="direccion" @onEdit="onEdit" />
                            </tbody>

                </table>
            </div>
        </div>
    </b-modal>
</div>


</template>

<script>

import axios from "axios";

export default {
name: "Directions",
	components: {

	},
	data(){
		return {
			form: { street: "", no_ext: "", suburb: "", municipality: "", state: "", cp: "", btw_streets: "", references: "", isEdit: true },
			is_loading: false,
			api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
			base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
			local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
			is_login: true,
			userData: {},
			cardData: {
				card_name: '',
				card_number: '',
				card_cvv: '',
				card_exp: ''
			},

      }
    },
    
props: {
    direction: {
        type: Object
    }
},
methods: {
    onEdit(){
        // window.console.log("directions edit" , this.directions.subscriber_id);
        this.$emit("onEdit", this.directions);
    }
}
}

</script>

<style lang="scss">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.modal-content {
    border-radius: 0 none;
    -moz-border-radius: 0 none;
    -webkit-border-radius: 0 none;
}

.site-footer {
    //background-image: url(images/backfooter.png); idk why doesn't aply 
    background-color: #000000;
    color: #fff !important;
}

.site-footer a {
    color: #fff;
    text-decoration: none;
}

.site-footer .footer-heading {
    color: #fff;
}

.site-footer .address,
.site-footer .email,
.site-footer .phone {
    color: #fff;
}

.site-footer .phone a {
    color: #fff;
    text-decoration: none;
}
</style>
